import React from 'react';

import Carousel, { SwiperSlide } from '@components/Carousel/Carousel';
import { SmallSearchViewModel } from '@api/index';

import { CarouselWrapper, Container, PageTitle } from './styled';
import HotelCard from './HotelCard';

const HotelRecommendations = ({ data }: { data: SmallSearchViewModel[] }) => {
  return (
    <Container>
      <PageTitle>Beğenebileceğiniz Diğer Oteller</PageTitle>
      <CarouselWrapper>
        <Carousel
          navigation
          loop={Boolean(data?.length > 3)}
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 10 },
            580: { slidesPerView: 2, spaceBetween: 15 },
            900: { slidesPerView: 3, spaceBetween: 20 },
            1200: { slidesPerView: 4, spaceBetween: 24 },
          }}
          slidesPerView={1}
        >
          {data?.map((item) => (
            <SwiperSlide key={item.id}>
              <HotelCard data={item} />
            </SwiperSlide>
          ))}
        </Carousel>
      </CarouselWrapper>
    </Container>
  );
};
export default HotelRecommendations;
